/* tslint:disable */

/**
 */
export class UserAction {
    id?: number;
    disable?: number;
}
